import { manutencao_cao_de_estrutura_para_escola } from "./manutencao-de-ensino";
import { manutencao_de_curso_para_escola } from "./manutencao-de-curso-para-escola";
import { manutencao_veto_transferencia } from "./manutencao-de-veto-de-transfrencia";
import { manutencao_retorno_vaga_para_escola } from "./manutencao-retorno-vaga-para-escola";
import { manutencao_estrutura } from "./manutencao-estrutura";

const paremetros_por_escola = [
  manutencao_cao_de_estrutura_para_escola,
  manutencao_de_curso_para_escola,
  manutencao_retorno_vaga_para_escola,
  manutencao_veto_transferencia,
  manutencao_estrutura,
];

export { paremetros_por_escola };
